/**
 * Batch Import Validators
 * Zod schemas for batch import validation
 */
import { z } from "zod";
/**
 * Single vehicle import schema
 */
export const vehicleImportSchema = z
    .object({
    brand: z.string().min(1, "Brand is required"),
    model: z.string().min(1, "Model is required"),
    mileageFrom: z.number().int().min(0).optional(),
    mileageTo: z.number().int().min(0).optional(),
    registrationFrom: z
        .string()
        .regex(/^\d{4}$/, "Invalid year format")
        .optional(),
    registrationTo: z
        .string()
        .regex(/^\d{4}$/, "Invalid year format")
        .optional(),
    powerFrom: z.number().int().min(0).optional(),
    powerTo: z.number().int().min(0).optional(),
    fuel: z.string().optional(),
    transmission: z.string().optional(),
    vehicleType: z.string().optional(),
    variants: z.array(z.string()).optional(),
    vin: z.string().length(17, "VIN must be 17 characters").optional(),
    customId: z.string().max(100).optional(),
})
    .refine((data) => !data.mileageFrom ||
    !data.mileageTo ||
    data.mileageFrom <= data.mileageTo, {
    message: "Mileage From must be less than or equal to Mileage To",
    path: ["mileageTo"],
})
    .refine((data) => !data.powerFrom || !data.powerTo || data.powerFrom <= data.powerTo, {
    message: "Power From must be less than or equal to Power To",
    path: ["powerTo"],
})
    .refine((data) => !data.registrationFrom ||
    !data.registrationTo ||
    parseInt(data.registrationFrom) <= parseInt(data.registrationTo), {
    message: "Registration From must be less than or equal to Registration To",
    path: ["registrationTo"],
});
/**
 * Batch import options schema
 */
export const batchImportOptionsSchema = z.object({
    batchListName: z
        .string()
        .trim()
        .min(1, "Batch list name is required")
        .max(100),
    skipDuplicates: z.boolean().default(false),
    continueOnError: z.boolean().default(true),
    configId: z.number().int().positive().optional(),
});
/**
 * Batch import execute request schema
 * Phase 22: Added vehiclesToSkip for selective duplicate handling
 */
export const executeSchema = z.object({
    vehicles: z.array(z.unknown()).min(1, "At least one vehicle is required"),
    options: batchImportOptionsSchema,
    vehiclesToSkip: z.array(z.number().int().positive()).optional(), // Phase 22: Row numbers to skip
});
//# sourceMappingURL=batchImport.schema.js.map